/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ColumnMetadata {
  /**
  * column name
  */
  'name': string;
  /**
  * type of the column
  */
  'type': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ColumnMetadata.attributeTypeMap;
  }

  public constructor() {
  }
}

